module.exports = __webpack_public_path__ + "static/media/1560445184510-2032832948.c2d60d05.jpg";